import { P } from "../../../../../../AbstractElements";
import CommonFileUpload from "../../../../../../Utils/CommonComponents/CommonFileUpload";
import ProductGallery from "./ProductGallery";

const ProductTwo = () => {
  return (
    <div className="sidebar-body">
      <div className="product-upload">
        <P>Product Image </P>
        <CommonFileUpload />
      </div>
      <ProductGallery />
    </div>
  );
};

export default ProductTwo;
